
export const WEEKDAY_KEYS = [
  { value: 0, key: 'mon' }, { value: 1, key: 'tue' }, { value: 2, key: 'wed' },
  { value: 3, key: 'thu' }, { value: 4, key: 'fri' }, { value: 5, key: 'sat' }, { value: 6, key: 'sun' },
];

export const COUNTRIES = [
  { code: 'UA', label: '🇺🇦 Україна' },
  { code: 'DE', label: '🇩🇪 Germany' },
  { code: 'US', label: '🇺🇸 USA' },
  { code: 'GB', label: '🇬🇧 UK' },
  { code: 'FR', label: '🇫🇷 France' },
  { code: 'IT', label: '🇮🇹 Italy' },
  { code: 'ES', label: '🇪🇸 Spain' },
  { code: 'PL', label: '🇵🇱 Poland' },
  { code: 'CZ', label: '🇨🇿 Czech' },
  { code: 'SK', label: '🇸🇰 Slovakia' },
  { code: 'HU', label: '🇭🇺 Hungary' },
  { code: 'RO', label: '🇷🇴 Romania' },
  { code: 'BG', label: '🇧🇬 Bulgaria' }

];

export const MIN_DAYS_BETWEEN_RACES = 6;